import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { experimentInt, isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';

import experiments from './experiments';
import {
  reverb_search_ListingsSearchRequest as ListingsSearchRequest,
  reverb_search_ListingItemRegionRelation as ItemRegionRelation,
} from './rql';

const MULTIVARIATE_EXPERIMENT_GROUP_TWO = 2;

function isNonUSUser(user: Partial<IUser>) {
  return !!user.countryCode && user.countryCode !== 'US';
}

export function trackLocalizeCSPCardExperiment(user: Partial<IUser>) {
  if (isNonUSUser(user)) {
    return [experiments.LOCALIZE_CSP_CARD];
  }

  return [];
}

export function trackLocalizeListingsRowExperiment(user: Partial<IUser>) {
  if (isNonUSUser(user)) {
    return [experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE];
  }

  return [];
}

export function trackLocalizeListingsRowDomesticExperiment(user: Partial<IUser>) {
  if (isNonUSUser(user)) {
    return [experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE_DOMESTIC];
  }

  return [];
}

export function trackLocalizeCspsExperiment(user: Partial<IUser>) {
  if (isNonUSUser(user)) {
    return [experiments.LOCALIZE_CSPS];
  }

  return [];
}

export function isUserInLocalizeCSPCardExperiment(user: Partial<IUser>) {
  const isEnabled = isExperimentEnabled(user, experiments.LOCALIZE_CSP_CARD);

  return isNonUSUser(user) && isEnabled;
}

export function isUserInLocalizeListingsRowsExperiment(user: Partial<IUser>) {
  const isEnabled = isExperimentEnabled(user, experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE);

  return isNonUSUser(user) && isEnabled;
}

export function isUserInLocalizeListingsRowsDomesticExperiment(user: Partial<IUser>) {
  const isEnabled = isExperimentEnabled(user, experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE_DOMESTIC);

  return isNonUSUser(user) && isEnabled;
}

export function isUserInLocalizeCspsExperiment(user: Partial<IUser>) {
  const isEnabled = isExperimentEnabled(user, experiments.LOCALIZE_CSPS);

  return isNonUSUser(user) && isEnabled;
}

export function localizeListingsRowsExperimentFilters(user: Partial<IUser>): ListingsSearchRequest {
  const isUserInExperiment = isUserInLocalizeListingsRowsExperiment(user);

  const userExperimentBucket = experimentInt(user, experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE);
  const isUserInExperimentGroupTwo = userExperimentBucket === MULTIVARIATE_EXPERIMENT_GROUP_TWO;

  if (isUserInExperiment && isUserInExperimentGroupTwo) {
    return {
      itemRegion: user.countryCode,
      itemRegionRelation: ItemRegionRelation.INCLUDE_TRADE_REGIONS,
    };
  }

  return {};
}

export function localizeListingsRowsDomesticExperimentFilters(user: Partial<IUser>): ListingsSearchRequest {
  const isUserInExperiment = isUserInLocalizeListingsRowsDomesticExperiment(user);

  const userExperimentBucket = experimentInt(user, experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE_DOMESTIC);
  const isUserInExperimentGroupTwo = userExperimentBucket === MULTIVARIATE_EXPERIMENT_GROUP_TWO;

  if (isUserInExperiment && isUserInExperimentGroupTwo) {
    return {
      itemRegion: user.countryCode,
    };
  }

  if (isUserInExperiment) {
    return {
      itemRegion: user.countryCode,
      itemRegionRelation: ItemRegionRelation.INCLUDE_TRADE_REGIONS,
    };
  }

  return {};
}

export function localizeCspsExperimentFilters(user: Partial<IUser>): string {
  return isUserInLocalizeCspsExperiment(user) ? user.countryCode : undefined;
}
